import clsx from 'clsx';
import { NavLink, Outlet } from 'react-router';
import { useCustomerMe } from '../lib/auth';

const tabs = [
  { to: '/app', label: 'Home', icon: '⌂', end: true },
  { to: '/app/wallet', label: 'Wallet', icon: '₹', feature: 'wallet' as const },
  { to: '/app/pay', label: 'Pay', icon: '⌗', feature: 'wallet' as const },
  { to: '/app/coupons', label: 'Rewards', icon: '★' },
  { to: '/app/profile', label: 'Profile', icon: '☺' },
];

/** Mobile-first shell for the customer PWA with a bottom tab bar. */
export function CustomerLayout() {
  const { data: me } = useCustomerMe();
  const visible = tabs.filter((t) => !t.feature || me?.features[t.feature]);
  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col bg-slate-50">
      <header className="sticky top-0 z-20 flex items-center justify-between bg-shell px-4 pb-3 pt-[max(0.75rem,env(safe-area-inset-top))] text-white">
        <span className="text-lg font-bold tracking-tight">
          {me?.business?.name ?? 'Carnival City'}
        </span>
        <NavLink to="/app/inbox" className="relative rounded-full px-2 py-1 text-sm text-slate-300 hover:bg-white/10" aria-label={`Inbox${me?.unread ? `, ${me.unread} unread` : ''}`}>
          Inbox
          {!!me?.unread && <span className="absolute -right-1 -top-1 min-w-5 rounded-full bg-accent-500 px-1 text-center text-xs font-semibold">{me.unread}</span>}
        </NavLink>
      </header>
      <main className="flex-1 px-4 pb-24 pt-4">
        <Outlet />
      </main>
      <nav aria-label="App" className="fixed inset-x-0 bottom-0 z-20 mx-auto max-w-md border-t border-slate-200 bg-white pb-[env(safe-area-inset-bottom)]">
        <ul className="flex">
          {visible.map((t) => (
            <li key={t.to} className="flex-1">
              <NavLink
                to={t.to}
                end={t.end}
                className={({ isActive }) => clsx('flex flex-col items-center gap-0.5 py-2 text-xs', isActive ? 'font-semibold text-brand-700' : 'text-slate-500')}
              >
                <span aria-hidden className="text-lg leading-none">
                  {t.icon}
                </span>
                {t.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
